"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledClose = exports.StyledChipButton = void 0;
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var prism_icons_1 = require("@octanner/prism-icons");
exports.StyledChipButton = (0, styles_1.styled)(material_1.ButtonBase)(function (_a) {
    var closeColor = _a.closeColor;
    return ({
        borderRadius: '16px',
        padding: '0',
        '&:focus': {
            outline: 'none',
        },
        height: '18px',
        width: '18px',
        backgroundColor: 'transparent',
        transition: 'background-color 0.3s',
        '&:hover': {
            transition: 'background-color 0.3s',
            backgroundColor: closeColor,
        },
    });
});
exports.StyledClose = (0, styles_1.styled)(prism_icons_1.Close)({
    height: '10px',
    width: '10px',
});
//# sourceMappingURL=styles.js.map